// The API only sends channel codes. These are the same display names the backend
// prints in the billing CSV/PDF, so the screen and the invoice read alike.
export const CHANNEL_DISPLAY_NAMES = {
  shopify: 'Shopify (app privada)',
  shopify_public: 'Shopify',
  shopify_fulfillment: 'Shopify Fulfillment',
  woocommerce: 'WooCommerce',
  vtex: 'Vtex',
  liverpool: 'Liverpool',
  meli: 'Mercado Libre',
  openapi: 'API',
  ventiapp: 'VentiApp',
  walmart: 'Walmart',
  tiendanube: 'Tiendanube',
  bling: 'Bling',
  bling_v3: 'Bling v3',
  coppel: 'Coppel',
  amazon: 'Amazon',
  f1commerce: 'F1commerce',
  traycorp: 'Tray Corp',
  traycommerce: 'Tray.',
  vnda: 'Vnda.',
  t1paginas: 'T1Páginas',
  vindi: 'Vindi',
  selia: 'Selia',
  tiny: 'Tiny',
  tiktokshop: 'TikTok Shop',
  privalia: 'Privalia',
  jet: 'Jet',
  entrada_unica: 'Entrada Única',
  shein: 'Shein',
  shopee: 'Shopee',
  anymarket: 'AnyMarket',
  stripe: 'Stripe',
  natura: 'Natura',
}

// Reserved values are not integrations, so their name is translated.
export const LOCALIZED_CHANNELS = ['manual', 'unidentified']

export const humanizeChannel = channelValue => {
  const words = String(channelValue || '').replace(/_/g, ' ')
  return words.charAt(0).toUpperCase() + words.slice(1)
}

export const channelDisplayName = (channelValue, i18n) => {
  if (LOCALIZED_CHANNELS.includes(channelValue)) {
    return i18n.t(`billing.channels.${channelValue}`)
  }

  return CHANNEL_DISPLAY_NAMES[channelValue] || humanizeChannel(channelValue)
}
